import { createApp } from 'vue'
import { createPinia } from 'pinia'
import './style.css'
import App from './App.vue'
import router from './router'
import Toast, { POSITION } from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import VueECharts from 'vue-echarts'
import EChartsPlugin from './plugins/echarts'
import { initializeTicketsStore } from './stores/useTicketsStore'

const app = createApp(App)
const pinia = createPinia()

app.component('v-chart', VueECharts)

app.use(pinia)
app.use(router)
app.use(Toast, {
  position: POSITION.TOP_RIGHT,
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false
})
app.use(EChartsPlugin)

// Inicializar store de tickets (modo webhook POST - WebSocket desactivado)
initializeTicketsStore().catch((error: Error) => {
  console.error('Error al inicializar store de tickets:', error);
});

app.mount('#app')
